import { Handle, Position } from '@xyflow/react';
import { PipelineStageDto } from '../../../types/pipelineStages';

interface PipelineStageNodeProps {
  data: {
    stage: PipelineStageDto;
    label?: string;
    status?: string;
  };
}

export default function PipelineStageNode({ data }: PipelineStageNodeProps) {
  const { stage } = data;

  const getStatusColor = (status: string) => {
    switch (status.toLowerCase()) {
      case 'succeeded': return 'bg-green-100 border-green-300 text-green-800';
      case 'failed': return 'bg-red-100 border-red-300 text-red-800';
      case 'inprogress': return 'bg-yellow-100 border-yellow-300 text-yellow-800';
      case 'canceled': return 'bg-gray-100 border-gray-300 text-gray-600';
      case 'skipped': return 'bg-blue-100 border-blue-300 text-blue-600';
      case 'waiting': return 'bg-orange-100 border-orange-300 text-orange-800';
      case 'notstarted': return 'bg-gray-50 border-gray-200 text-gray-500';
      default: return 'bg-gray-100 border-gray-300 text-gray-600';
    }
  };

  return (
    <div className={`px-4 py-3 rounded-lg border-2 shadow-sm min-w-[160px] max-w-[280px] ${getStatusColor(stage.status)}`}>
      <Handle
        type="target"
        position={Position.Left}
        className="w-3 h-3 bg-blue-500 border-2 border-white rounded-full"
      />
      
      <div className="font-semibold text-sm mb-1 leading-tight break-words text-center">
        {stage.displayName || stage.name}
      </div>
      
      <div className="text-xs capitalize text-center">
        {stage.status.replace(/([A-Z])/g, ' $1').trim()}
      </div>

      <Handle
        type="source"
        position={Position.Right}
        className="w-3 h-3 bg-blue-500 border-2 border-white rounded-full"
      />
    </div>
  );
}